export default function Card({ title, value, color }) {
  return (
    <div
      className={`${color} rounded-xl shadow-xl p-10 flex flex-col items-center justify-center text-center text-white hover:scale-105 hover:shadow-xl transition-all duration-300`}
    >
      
      <h3 className="text-[28px] font-medium text-white tracking-wide">
        {title}
      </h3>

      <p className="text-3xl font-semibold mt-2">
        {value || 0}
      </p>
    </div>
  );
}